angular.module('main').directive('elastic', [
	'$timeout',
	function($timeout) {
		return {
			restrict: 'A',
			link($scope, element) {
				$scope.initialHeight = $scope.initialHeight || element[0].style.height;

				const resize = function() {
					element[0].style.height = $scope.initialHeight;
					element[0].style.height = `${element[0].scrollHeight}px`;
				};
				element.on('input change', resize);
				$timeout(resize, 0);
			}
		};
	}
]);



// WEBPACK FOOTER //
// ./web/js/components/textAreaElastic.js